import dynamic from 'next/dynamic';
import { ReservationLookupTypes } from './ReservationLookup.types';

export const ReservationLookup = dynamic<ReservationLookupTypes>(() =>
  import('./ReservationLookup').then(module => module.ReservationLookup)
);
